import clsx from 'clsx';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './metallic-pill-button.css';

type Size = 'sm' | 'md' | 'lg';

export type MetallicPillButtonProps = {
  children: ReactNode;
  size?: Size;
  className?: string;
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'>;

export default function MetallicPillButton({
  children,
  size = 'md',
  className,
  type = 'button',
  ...rest
}: MetallicPillButtonProps) {
  return (
    <button
      type={type}
      className={clsx(
        'metallic-pill',
        size === 'sm' && 'metallic-pill--sm',
        size === 'lg' && 'metallic-pill--lg',
        className
      )}
      {...rest}
    >
      <span className="metallic-pill__inner">{children}</span>
    </button>
  );
}
